import Instance from "../../../../Axios";

// New Actions for the app

const GetObrasAHDAdmin = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/ahd/obras/admin`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_OBRAS_AHD_ADMIN", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObrasAHDAdmin;
